import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createnewfile">
                1.&nbsp;<span className="material-symbols-outlined">note_add</span>&nbsp;{translate('createnewfile')}
            </Typography>
            <p><strong>{translate('createnewfile')}</strong> is an action used to create an excel file. The default generated file has 1 sheet named <strong>Sheet</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$newFileExcel_1</td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the directory path where the file is saved. Type <strong>/tmp</strong> to specify the root directory.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the name of the Excel file.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newFileExcel_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('directory')}</span>
                            <div>/tmp/directory-name/</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>file-name.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getsheetnames">
                2.&nbsp;<span className="material-symbols-outlined">format_list_bulleted</span>&nbsp;{translate('getsheetnames')}
            </Typography>
            <p><strong>{translate('getsheetnames')}</strong> is an action that gets all the names of the sheet in an Excel file as an array.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$sheetNames_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the Excel file.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$sheetNames_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "sheet"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="changesheetname">
                3.&nbsp;<span className="material-symbols-outlined">published_with_changes</span>&nbsp;{translate('changesheetname')}
            </Typography>
            <p><strong>{translate('changesheetname')}</strong> is the act of changing the name of a sheet in an Excel file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the Excel file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the original name of the sheet you want to change.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('newsheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The new name of the sheet.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>sheet</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('newsheetname')}</span>
                            <div>new sheet</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="selectsheet">
                4.&nbsp;<span className="material-symbols-outlined">grid_on</span>&nbsp;{translate('selectsheet')}
            </Typography>
            <p><strong>{translate('selectsheet')}</strong> is an action to select a sheet. To perform operations on Excel, users first need to select the worksheet to operate on.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$workSheet_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the Excel file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>The name of the sheet.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/file-name.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "filePath": "/tmp/directory-name/file-name.xlsx",
                                            "sheetName": "Sheet"
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readcell">
                5.&nbsp;<span className="material-symbols-outlined">font_download</span>&nbsp;{translate('readcell')}
            </Typography>
            <p><strong>{translate('readcell')}</strong> is the act of reading the value of a cell in a worksheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$cellValue_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is the destination sheet.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the cell label to read.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$cellValue_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>123</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writecell">
                6.&nbsp;<span className="material-symbols-outlined">edit_square</span>&nbsp;{translate('writecell')}
            </Typography>
            <p><strong>{translate('writecell')}</strong> is the act of writing a value to a cell in a worksheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is the destination sheet.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the cell label to write.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the input value.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>456</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('newsheetname')}</span>
                            <div>456</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readrange">
                7.&nbsp;<span className="material-symbols-outlined">type_specimen</span>&nbsp;{translate('readrange')}
            </Typography>
            <p><strong>{translate('readrange')}</strong> is the act of reading values within a specified range of a worksheet into a two-dimensional array.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$rangeValue_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is the destination sheet.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the cell label to read.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$rangeValue_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B2</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                123,
                                                null
                                            ],
                                            [
                                                456,
                                                null
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writerange">
                8.&nbsp;<span className="material-symbols-outlined">app_registration</span>&nbsp;{translate('writerange')}
            </Typography>
            <p><strong>{translate('writerange')}</strong> is the act of writing an array to a sheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is the destination sheet.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('celllabel')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the cell label to write.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Is the input value.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('celllabel')}</span>
                            <div>A1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                123,
                                                "abc"
                                            ],
                                            [
                                                456,
                                                "def"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="deleterange">
                9.&nbsp;<span className="material-symbols-outlined">backspace</span>&nbsp;{translate('deleterange')}
            </Typography>
            <p><strong>{translate('deleterange')}</strong> is the act of deleting values within a specified range of a worksheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is the destination sheet.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the cell label to write.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B2</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertexceltocsv">
                10.&nbsp;<span className="material-symbols-outlined">restore_page</span>&nbsp;{translate('convertexceltocsv')}
            </Typography>
            <p><strong>{translate('convertexceltocsv')}</strong> is the act of converting an Excel file's worksheet into a new CSV file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$excelToCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('worksheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Is the destination sheet.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the new name of the CSV file.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$workSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>Sheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sheet.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="writecsv">
                11.&nbsp;<span className="material-symbols-outlined">text_snippet</span>&nbsp;{translate('writecsv')}
            </Typography>
            <p><strong>{translate('writecsv')}</strong> is the act of creating a new CSV file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$newFileCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the name of the CSV file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Is the value written to the CSV file. (values are in two-dimensional array)</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                    <div className='parameter'>
                            <span className='parameter-name'>{translate('worksheet')}</span>
                            <div>$newFileCSV_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>Sample</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "No",
                                                "01",
                                                "02"
                                            ],
                                            [
                                                "Product",
                                                "Pen",
                                                "Note"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readcsv">
                12.&nbsp;<span className="material-symbols-outlined">document_scanner</span>&nbsp;{translate('readcsv')}
            </Typography>
            <p><strong>{translate('readcsv')}</strong> is the act of reading a CSV file as an array.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$readCSV_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the CSV file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Specify the character encoding of the archive. If the filename after expansion contains Japanese characters, the characters may be garbled. You can prevent garbled characters by specifying a character code.</td>
                                <td>UTF-8</td>
                            </tr>
                            <tr>
                                <td>{translate('headers')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="boolean" />
                                </td>
                                <td>As the header row, if the <strong>{translate('header')}</strong> switch is on (true), the results include the first line as well.</td>
                                <td>true</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$readCSV_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('headers')}</span>
                            <div>true</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "No",
                                                "01",
                                                "02"
                                            ],
                                            [
                                                "Product",
                                                "Pen",
                                                "Note"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="changedelimitercsvfile">
                13.&nbsp;<span className="material-symbols-outlined">published_with_changes</span>&nbsp;{translate('changedelimitercsvfile')}
            </Typography>
            <p><strong>{translate('changedelimitercsvfile')}</strong> is the act of changing the character that separates columns in a CSV file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$changeDelimiterCsvFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the CSV file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('from')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is a current separator character.</td>
                                <td>;</td>
                            </tr>
                            <tr>
                                <td>{translate('to')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is a delimiter character you want to replace.</td>
                                <td>,</td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Specify the character encoding of the archive. If the filename after expansion contains Japanese characters, the characters may be garbled. You can prevent garbled characters by specifying a character code.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$csvFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('from')}</span>
                            <div>;</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('to')}</span>
                            <div>,</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="appendvaluetocsvfile">
                14.&nbsp;<span className="material-symbols-outlined">post_add</span>&nbsp;{translate('appendvaluetocsvfile')}
            </Typography>
            <p><strong>{translate('appendvaluetocsvfile')}</strong> is the act of appending rows to a CSV file.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the place to store the output of this action.</td>
                                <td>$csvFile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the path of the CSV file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Is the value written to the CSV file. (values are in two-dimensional array)</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('position')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the row position to append. Specify value <strong>0</strong> to add to the beginning of the file <strong>end</strong> to add to the end of the file.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('delimiter')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is a one-character used to separate columns.</td>
                                <td>,</td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Specify the character encoding of the archive. If the filename after expansion contains Japanese characters, the characters may be garbled. You can prevent garbled characters by specifying a character code.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$csvFile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "03",
                                                "04"
                                            ],
                                            [
                                                "Ruler",
                                                "Eraser"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('delimiter')}</span>
                            <div>,</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('position')}</span>
                            <div>end</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/directory-name/Sample.csv</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(En);